var React = require('react');

function Html5 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M36.683,6H8.61249l.233,2.69531,2.4234,28.03094.14752,1.7066L13.06451,38.9l10.25916,2.90808L24.00043,42l.67682-.19189L34.9364,38.9l1.648-.46716.14752-1.7066L39.1554,8.69531,39.38843,6ZM34.25958,36.27173l-10.25916,3.0285L13.74127,36.21155,11.31787,8H36.683Z","key":0}),React.createElement("polygon",{"points":"15.276 24.638 14.226 12.521 33.694 12.521 33.371 16.56 18.507 16.56 18.83 20.679 33.048 20.679 31.917 32.877 24 35.139 16.003 32.877 15.518 26.657 19.396 26.657 19.638 29.808 24 31.019 28.282 29.808 28.767 24.638 15.276 24.638","style":{"fillRule":"evenodd"},"key":1})]);
}

Html5.displayName = "Html5";

Html5.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Html5;

Html5.default = Html5;



// WEBPACK FOOTER //
// ./node_modules/pui-css-iconography/svgs/html5.svg